import {
	CHAIN_SHORT_OPTIONS,
	CRYPTO_TICKER_OPTIONS,
	FIAT_OPTIONS,
} from "@oxygen/concepts";
import { CryptoIcon } from "src/components/crypto-icon/crypto-icon";

export const cryptoTickerOptions = CRYPTO_TICKER_OPTIONS.map((opt) => ({
	value: opt.value,
	label: opt.label,
	icon: (
		<CryptoIcon
			ticker={opt.value}
			showComposite={opt.isComposite}
			className="h-4 w-4"
		/>
	),
}));

export const chainShortOptions = CHAIN_SHORT_OPTIONS.map((opt) => ({
	value: opt.value,
	label: opt.label,
	icon: <CryptoIcon ticker={opt.value} className="h-4 w-4" />,
}));

export const fiatOptions = FIAT_OPTIONS;
